import GasolineSlider from "./GasolineSlider";
import ElectricSlider from "./ElectricSlider";
import DualMotorSlider from "./DualMotorSlider";

const ModelSlider = () => {
  return (
    <div className="grid lg:grid-cols-3 grid-cols-1 gap-8 mb-8 lg:items-stretch">
      <div className="flex flex-col">
        <h3 className="font-[Rockwell] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px] text-[#292929] text-center mb-4">
          GASOLINE
        </h3>
        <GasolineSlider compact />
      </div>
      <div className="flex flex-col">
        <h3 className="font-[Rockwell] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px] text-[#292929] text-center mb-4">
          ELECTRIC
        </h3>
        <ElectricSlider compact />
      </div>
      <div className="flex flex-col">
        <h3 className="font-[Rockwell] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px] text-[#292929] text-center mb-4">
          DUAL MOTOR
        </h3>
        <DualMotorSlider compact />
      </div>
    </div>
  );
};

export default ModelSlider;
